import { FC, useRef } from 'react'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { FlexboxGrid, Loader } from 'rsuite'

import { useApi } from '../../../services/useApi'
import useWhenVisible from '../../../services/useWhenVisible'
import SupplierCarousel from './SupplierCarousel'
import { createUrlParams } from '../../../lib/params'
import { Supplier, SupplierMappedProductsProps } from '../../../utils/types/Product'
import useMounted from '../../../services/useMounted'
import { QueryParam, SortOption } from '../../../utils/constants'

import styles from '../../../styles/SupplierCatalog.module.less'

interface SuppliersListProps {
  supplierMappedProducts: SupplierMappedProductsProps[]
  loadingSuppliers?: boolean
}

const SuppliersList: FC<SuppliersListProps> = (props) => {
  // TODO: doesn't consider language now, should later filter based on
  //  text.languageid and current saved client language
  const {
    supplierMappedProducts,
    loadingSuppliers,
  } = props

  const { t } = useTranslation('products')
  const endElement = useRef<HTMLDivElement>(null)
  const { getResource } = useApi()
  const { query } = useRouter()
  const isMounted = useMounted()

  const sortQuery = query[QueryParam.sort]

  let sortParam = 'supplier.address.position'
  switch (sortQuery) {
    case SortOption.newest:
      sortParam = '-supplier.ctime'
      break
    case SortOption.name_az:
      sortParam = 'supplier.label'
      break
    case SortOption.name_za:
      sortParam = '-supplier.label'
      break
    default:
      break
  }
  const supplierQuery = createUrlParams({
    include: ['media', 'text', 'supplier/address', 'supplier/service', 'service/price'],
    sort: sortParam,
    page: {
      limit: '24',
    },
  })

  const { data, loadMore, total } = getResource<Supplier>('supplier', supplierQuery)

  useWhenVisible(() => {
    if (data.length < total) {
      loadMore()
    }
  }, endElement, [supplierMappedProducts, total])

  return (
    <div className={styles.container}>
      {supplierMappedProducts.map((supplier) => (
        <SupplierCarousel
          key={supplier.id}
          supplier={supplier}
        />
      ))}
      {isMounted && (total > data.length || loadingSuppliers) && (
        <FlexboxGrid
          justify="center"
          className="margin-top-spacer-quadruple"
        >
          <FlexboxGrid.Item>
            <Loader content={t('common:Loading')} />
            <div ref={endElement} />
          </FlexboxGrid.Item>
        </FlexboxGrid>
      )}
    </div>
  )
}
export default SuppliersList
